import Button from "@material-ui/core/Button";
import React from "react";
import styles from "./style.module.css";

export default React.memo(({ timeLeft, ...rest }) =>
  <Button
    classes={{
      root: styles.root,
      disabled: styles.disabled,
    }}
    {...rest}
  >
    {`Resend${timeLeft ? ` :${timeLeft}` : ""}`}
  </Button>,
);

